import React, { useState, useEffect } from "react"

const CountdownTimer = ({
  startDate,
  endDate,
  fridayPromotion,
  thursdayPromotion,
}) => {
  const calculateTimeLeft = () => {
    const now = new Date()
    let target

    if (thursdayPromotion) {
      const dayOfWeek = now.getDay()
      let thursday4PM = new Date(now)
      thursday4PM.setDate(now.getDate() + ((4 - dayOfWeek + 7) % 7))
      thursday4PM.setHours(16, 0, 0, 0)

      let thursday6PM = new Date(thursday4PM)
      thursday6PM.setHours(18, 0, 0, 0)

      let friday12PM = new Date(thursday4PM)
      friday12PM.setDate(thursday4PM.getDate() + 1)
      friday12PM.setHours(12, 0, 0, 0)

      if (now < thursday4PM) {
        target = thursday4PM
      } else if (now >= thursday4PM && now < thursday6PM) {
        target = thursday6PM
      } else if (now >= thursday6PM && now < friday12PM) {
        target = friday12PM
      } else {
        // If today is after Friday 12PM, move to next Thursday
        thursday4PM.setDate(thursday4PM.getDate() + 7)
        target = thursday4PM
      }
    } else if (fridayPromotion) {
      const dayOfWeek = now.getDay()
      let fridayTarget = new Date(now)
      fridayTarget.setDate(now.getDate() + ((5 - dayOfWeek + 7) % 7))
      fridayTarget.setHours(12, 0, 0, 0)

      if (now >= fridayTarget) {
        fridayTarget.setDate(fridayTarget.getDate() + 7)
      }

      target = fridayTarget
    } else {
      target =
        now < new Date(startDate) ? new Date(startDate) : new Date(endDate)
    }

    const difference = target - now

    if (difference <= 0) return {}

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hrs: Math.floor((difference / (1000 * 60 * 60)) % 24),
      mins: Math.floor((difference / (1000 * 60)) % 60),
      secs: Math.floor((difference / 1000) % 60),
    }
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000)
    return () => clearInterval(timer)
  }, [startDate, endDate, fridayPromotion, thursdayPromotion])

  const getLabel = () => {
    const now = new Date()

    if (fridayPromotion) return "Next Friday (12 PM):"

    if (thursdayPromotion) {
      const dayOfWeek = now.getDay()

      const thursday4PM = new Date(now)
      thursday4PM.setDate(now.getDate() + ((4 - dayOfWeek + 7) % 7))
      thursday4PM.setHours(16, 0, 0, 0)

      const thursday6PM = new Date(thursday4PM)
      thursday6PM.setHours(18, 0, 0, 0)

      const friday12PM = new Date(thursday4PM)
      friday12PM.setDate(friday12PM.getDate() + 1)
      friday12PM.setHours(12, 0, 0, 0)

      if (now < thursday4PM) return "Draw Closes (Thu 4 PM):"
      if (now >= thursday4PM && now < thursday6PM)
        return "Draw Live (Thu 6 PM):"
      if (now >= thursday6PM && now < friday12PM)
        return "Resetting (Fri 12 PM):"

      return "Draw Closes (Next Thu 4 PM):"
    }

    return now < new Date(startDate) ? "Starts In:" : "Ends At:"
  }

  const padNumber = (num) => String(num).padStart(2, "0")

  return (
    <div className="fgh-countdown-timer">
      <strong>{getLabel()}</strong>
      <div className="fgh-countdown-info">
        {Object.keys(timeLeft).length ? (
          <>
            <p>
              <span className="countdown-timer">
                {padNumber(timeLeft.days)}
              </span>
              <span className="countdown-schedule"> days</span>
            </p>
            <p>
              <span className="countdown-timer">{padNumber(timeLeft.hrs)}</span>
              <span className="countdown-schedule"> hrs</span>
            </p>
            <p>
              <span className="countdown-timer">
                {padNumber(timeLeft.mins)}
              </span>
              <span className="countdown-schedule"> mins</span>
            </p>
            <p>
              <span className="countdown-timer">
                {padNumber(timeLeft.secs)}
              </span>
              <span className="countdown-schedule"> secs</span>
            </p>
          </>
        ) : (
          <span>Time's up!</span>
        )}
      </div>
    </div>
  )
}

export default CountdownTimer
